import api from "@/api/api-v2-config";

export async function getEmailCampaignAxios() {    
    return await api.get("marketings/getemailcampaignlist?PageNumber=1&PageSize=10000");
}

export async function deleteEmailCampaignAxios(id) {    
    return await api.delete("marketings/deleteemailcampaign?id=" + id);
}

export async function postEmailCampaignAxios(item) {    
    return await api.post("marketings/createemailcampaign", item);
}

export async function putEmailCampaignAxios(item) {    
    return await api.put("marketings/updateemailcampaign", item);
}

export async function getEmailCampaignByIdAxios(id) {
    return await api.get("marketings/getemailcampaignbyid?id=" + id);
}


export async function updateCampaignStatus(id, status) {
    return await api.put(`marketings/updateemailcampaignstatus/${id}?status=${status}`);
}